import React, { Component } from 'react';
import { Table, Row, Col, InputNumber, Button, DatePicker, message, Spin, Input } from 'antd';
import moment from 'moment';
import { data3_2_1 } from './data';
import imgSave from "../../saveImg";
import Auth from "../../Auth";
import Compared from "../../Compared";
import { Prompt } from 'react-router-dom';
import ExportExcel from "@/method/components/ExportExcel"
const { MonthPicker } = DatePicker;

function numChange(text = 0) {

    let html = Number(text || '0') < 0 ?
        <span style={{ color: "red" }}>
            ({Math.abs(Number(text || "0")).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')})
        </span>
        :
        Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return html;

}

class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().subtract(1, 'month').format('YYYY-MM'),
            data: [],
            loading: true,
            loadingSave: false,
            print: false,
            isEdit: false
        }
    }


    componentDidMount() {
        this.getDateData(this.state.date);
        //在关闭页面时弹出确认提示窗口
        window.addEventListener('beforeunload', this.handleWindowClose);
    }

    // 监测5.1.3保存情况
    componentWillReceiveProps(nextProps) {
        if (nextProps.update != this.props.update && nextProps.update) {
            this.setState({
                data: [],
                loading: true
            });
            this.getDateData(this.state.date);
            this.props.onChange('update5_1_3', false);
        }
    }

    handleWindowClose = (ev) => {
        const confirmationMessage = "5.1.4 数据还未保存,确定要离开吗?";
        (ev || window.event).returnValue = confirmationMessage;
        if (this.state.isEdit) {
            return confirmationMessage;
        }
    }

    componentWillUnmount() {
        window.removeEventListener('beforeunload', this.handleWindowClose);
    }

    computeNum = (data) => {
        const numConvert = (num = 0) => {
            num = Number(num || "0")
            return num
        };

        // 计算total
        const totalNameData = ['covers', 'REV', 'cost', 'm_covers', 'm_REV', 'm_cost'];
        for (let i = 0; i < totalNameData.length; i++) {
            data[13][totalNameData[i]] = data.reduce((a, b, index) => {
                if (index != 13 && index != 14 && index != 15 && index != 16) {
                    a += Number(b[totalNameData[i]] || '0');
                }
                return a
            }, 0);
            data[13][totalNameData[i]] = data[13][totalNameData[i]].toFixed(0);
        };

        for (let i = 0; i < 14; i++) {
            data[i].business = (numConvert(data[13].covers) == 0 ? 0 : numConvert(data[i].covers) / numConvert(data[13].covers)).toFixed(3);
            data[i].AC = (numConvert(data[i].covers) == 0 ? 0 : numConvert(data[i].REV) / numConvert(data[i].covers)).toFixed(0);
            data[i].revenue = (numConvert(data[13].REV) == 0 ? 0 : numConvert(data[i].REV) / numConvert(data[13].REV)).toFixed(3);
            data[i].cost_percent = (numConvert(data[i].REV) == 0 ? 0 : numConvert(data[i].cost) / numConvert(data[i].REV)).toFixed(3);
            data[i].m_business = (numConvert(data[13].m_covers) == 0 ? 0 : numConvert(data[i].m_covers) / numConvert(data[13].m_covers)).toFixed(3);
            data[i].m_AC = (numConvert(data[i].m_covers) == 0 ? 0 : numConvert(data[i].m_REV) / numConvert(data[i].m_covers)).toFixed(0);
            data[i].m_revenue = (numConvert(data[13].m_REV) == 0 ? 0 : numConvert(data[i].m_REV) / numConvert(data[13].m_REV)).toFixed(3);
            data[i].m_cost_percent = (numConvert(data[i].m_REV) == 0 ? 0 : numConvert(data[i].m_cost) / numConvert(data[i].m_REV)).toFixed(3);

            data[i].b_covers = (numConvert(data[i].covers) - numConvert(data[i].m_covers)).toFixed(0);
            data[i].b_business = (numConvert(data[i].business) - numConvert(data[i].m_business)).toFixed(3);
            data[i].b_AC = (numConvert(data[i].AC) - numConvert(data[i].m_AC)).toFixed(0);
            data[i].b_REV = (numConvert(data[i].REV) - numConvert(data[i].m_REV)).toFixed(0);
            data[i].b_revenue = (numConvert(data[i].revenue) - numConvert(data[i].m_revenue)).toFixed(3);
            data[i].b_cost = (numConvert(data[i].cost) - numConvert(data[i].m_cost)).toFixed(0);
            data[i].b_cost_percent = (numConvert(data[i].cost_percent) - numConvert(data[i].m_cost_percent)).toFixed(3);
        }

        // 计算设施收入 其他收入 合计收入
        data[16].REV = (numConvert(data[15].REV) + numConvert(data[14].REV) + numConvert(data[13].REV)).toFixed(0);
        data[16].m_REV = (numConvert(data[15].m_REV) + numConvert(data[14].m_REV) + numConvert(data[13].m_REV)).toFixed(0);
        data[14].b_REV = (numConvert(data[14].REV) - numConvert(data[14].m_REV)).toFixed(0);
        data[15].b_REV = (numConvert(data[15].REV) - numConvert(data[15].m_REV)).toFixed(0);
        data[16].b_REV = (numConvert(data[16].REV) - numConvert(data[16].m_REV)).toFixed(0);
        this.setState({
            data
        });

    }
    onChange = (name, value, i) => {
        let data = this.state.data;
        data[i][name] = value;
        this.computeNum(data);
        this.setState({ isEdit: true });
    }

    getDateData = async (date) => {
        const dataBegin = JSON.stringify(data3_2_1);
        let data = JSON.parse(dataBegin);
        try {
            let d5_3 = await fetch(`/_5_1_3_info?year=${moment(date).format('YYYY')}&month=${moment(date).format('M')}`, { credentials: 'include' });
            let j5_3 = await d5_3.json();
            let d5_4 = await fetch(`/_5_1_4_info?year=${moment(date).format('YYYY')}&month=${moment(date).format('M')}`, { credentials: 'include' });
            let j5_4 = await d5_4.json();
            let lastd5_3 = await fetch(`/_5_1_3_info?year=${moment(date).format('YYYY') - 1}&month=${moment(date).format('M')}`, { credentials: 'include' });
            let lastj5_3 = await lastd5_3.json();
            if (j5_4.data && j5_4.data.length > 0) {
                data = j5_4.data;
            }
            if (j5_3.data && j5_3.data.length > 0) {
                data = data.map((z, i) => {
                    return ({
                        ...z,
                        name: j5_3.data[i].name,
                        name_code: j5_3.data[i].name_code,
                        covers: j5_3.data[i].covers,
                        business: j5_3.data[i].business,
                        AC: j5_3.data[i].AC,
                        REV: j5_3.data[i].REV,
                        revenue: j5_3.data[i].revenue,
                        cost: j5_3.data[i].cost,
                        cost_percent: j5_3.data[i].cost_percent,
                    })
                })
            }

            // 插入去年当月5——3数据
            if (lastj5_3.data && lastj5_3.data.length > 0) {
                data = data.map((z, i) => {
                    if (z.name != lastj5_3.data[i].name) {
                        return { ...z }
                    }
                    return ({
                        ...z,
                        m_covers: z.m_covers != 0 ? z.m_covers : lastj5_3.data[i].covers,
                        m_business: z.m_business != 0 ? z.m_business : lastj5_3.data[i].business,
                        m_AC: z.m_AC != 0 ? z.m_AC : lastj5_3.data[i].AC,
                        m_REV: z.m_REV != 0 ? z.m_REV : lastj5_3.data[i].REV,
                        m_revenue: z.m_revenue != 0 ? z.m_revenue : lastj5_3.data[i].revenue,
                        m_cost: z.m_cost != 0 ? z.m_cost : lastj5_3.data[i].cost,
                        m_cost_percent: z.m_cost_percent != 0 ? z.m_cost_percent : lastj5_3.data[i].cost_percent,
                    })
                })
            }

            this.setState({ loading: false });
            this.computeNum(data);
        } catch (error) {
            console.log(error);
            this.setState({ loading: false });
        }
    }

    onSave = () => {
        this.setState({ loadingSave: true });
        let date = this.state.date;
        if (!date) {
            message.error('请选择年份月份');
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            return
        }
        let year = moment(date).format("YYYY");
        let month = moment(date).format("M");
        let data = this.state.data.map((x, i) => ({ ...x, year, month, }));
        // if (!data.every(x => x.name)) {
        //     message.error('名称不能为空，请到3-1-1设置名称！');
        //     return
        // }
        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify(data));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        fetch('/add_5_1_4', headres).then(x => x.json()).then(x => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false, isEdit: false }); clearTimeout(timer) }, 1000)
            if (x.status == 1) {
                message.success(x.msg);
                if (!data[0].id) {
                    this.getDateData(this.state.date);
                }
                return
            }
            message.error(x.msg);
        }).catch(err => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            console.error(err);
            message.error('保存失败' + JSON.stringify(err));
        })
    }

    downloadSG = () => {

        this.setState({ print: true, loading: true }, () => {
            imgSave('table5_1_4', 1.5, '5.14', this.state.date).then(x => {
                if (x.status == 1) {
                    message.info('添加成功！');
                } else {
                    message.error('添加失败' + x.msg);
                }

                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                this.setState({
                    print: false,
                    loading: false
                });
            })

        });

    }

    render() {
        const { data, date, print } = this.state;
        const width = document.body.offsetWidth - 3150 > 300 ? document.body.offsetWidth - 3150 : 300;
        const noInputData = [13, 14, 15, 16];
        const columns = [{
            title: 'Outlets & Others 餐厅及其他',
            dataIndex: 'name',
            key: 'name',
            align: "center",
            fixed: !print && "left",
            width,
            render: (text, record, index) => {
                return (
                    <div className={`table-padding ${index == 13 || index == 16 ? 'table-color-footer' : ''} `} style={{ textAlign: "left" }}>
                        {text}
                    </div>
                )
            }
        }, {
            title: 'YTD Actual - This Year 年累计实际-今年',
            width: 1050,
            children: [{
                title: <div>Covers <br />人数</div>,
                dataIndex: 'covers',
                key: 'covers',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['YTD Actual - This Year 年累计实际-今年', 'Covers 人数'];
                    return (
                        <Compared data={{ index, key: 'covers', title, sqlName: "_5_1_4", name: record.name, type: 'number' }} >
                            <div className={`table-padding ${index == 13 || index == 16 ? 'table-color-footer' : ''} `}>
                                {Number(text || '0') < 0 ?
                                    <span style={{ color: "red" }}>
                                        ({Math.abs(Number(text || "0")).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')})
                                    </span>
                                    :
                                    Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                                }
                            </div>
                        </Compared>
                    )
                }
            }, {
                title: <div>Business Mix <br />业务份额</div>,
                dataIndex: 'business',
                key: 'business',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['YTD Actual - This Year 年累计实际-今年', 'Business Mix 业务份额'];
                    return (
                        <Compared data={{ index, key: 'business', title, sqlName: "_5_1_4", name: record.name, type: 'percent' }} >
                            <div className={`table-padding ${index == 13 || index == 16 ? 'table-color-footer' : ''} `}>
                                {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(1) + '%'})</span> : (text * 100).toFixed(1) + '%'}
                            </div>
                        </Compared>
                    )
                }
            }, {
                title: <div>A/C <br />人均消费</div>,
                dataIndex: 'AC',
                key: 'AC',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['YTD Actual - This Year 年累计实际-今年', 'A/C 人均消费'];
                    return (
                        <Compared data={{ index, key: 'AC', title, sqlName: "_5_1_4", name: record.name, type: 'number' }} >
                            <div className={`table-padding ${index == 13 || index == 16 ? 'table-color-footer' : ''} `}>
                                {numChange(text)}
                            </div>
                        </Compared>
                    )

                }
            }, {
                title: <div>REV <br />收益</div>,
                dataIndex: 'REV',
                key: 'REV',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['YTD Actual - This Year 年累计实际-今年', 'REV 收益'];
                    return (
                        <Compared data={{ index, key: 'REV', title, sqlName: "_5_1_4", name: record.name, type: 'number' }} >
                            <div className={`table-padding ${index == 13 || index == 16 ? 'table-color-footer' : ''} `}>
                                {numChange(text)}
                            </div>
                        </Compared>
                    )
                }
            }, {
                title: <div>Revenue Mix<br /> 收入份额</div>,
                dataIndex: 'revenue',
                key: 'revenue',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['YTD Actual - This Year 年累计实际-今年', 'Revenue Mix 收入份额'];
                    return (
                        <Compared data={{ index, key: 'revenue', title, sqlName: "_5_1_4", name: record.name, type: 'percent' }} >
                            <div className={`table-padding ${index == 13 || index == 16 ? 'table-color-footer' : ''} `}>
                                {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(1) + '%'})</span> : (text * 100).toFixed(1) + '%'}
                            </div>
                        </Compared>
                    )
                }
            }, {
                title: <div>Cost Amount <br /> 成本金额</div>,
                dataIndex: 'cost',
                key: 'cost',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['YTD Actual - This Year 年累计实际-今年', 'Cost Amount 成本金额'];
                    return (
                        <Compared data={{ index, key: 'cost', title, sqlName: "_5_1_4", name: record.name, type: 'number' }} >
                            <div className={`table-padding ${index == 13 || index == 16 ? 'table-color-footer' : ''} `}>
                                {numChange(text)}
                            </div>
                        </Compared>
                    )
                }
            }, {
                title: <div>Cost %  <br /> 成本百分比</div>,
                dataIndex: 'cost_percent',
                key: 'cost_percent',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['YTD Actual - This Year 年累计实际-今年', 'Cost % 成本百分比'];
                    return (
                        <Compared data={{ index, key: 'cost_percent', title, sqlName: "_5_1_4", name: record.name, type: 'percent' }} >
                            <div className={`table-padding ${index == 13 || index == 16 ? 'table-color-footer' : ''} `}>
                                {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(1) + '%'})</span> : (text * 100).toFixed(1) + '%'}
                            </div>
                        </Compared>
                    )
                }
            },]
        }, {
            title: 'YTD Actual - Last Year 年累计实际-去年',
            width: 1050,
            children: [{
                title: <div>Covers <br />人数</div>,
                dataIndex: 'm_covers',
                key: 'm_covers',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['YTD Actual - Last Year 年累计实际-去年', 'Covers 人数'];
                    if (!noInputData.includes(index) && !print) {
                        return (
                            <Compared data={{ index, key: 'm_covers', title, sqlName: "_5_1_4", name: record.name, type: 'number' }} >
                                <div className="table-padding table-color-number">
                                    <InputNumber
                                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                        parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                        precision={0}
                                        className="table_numInput"
                                        defaultValue={text}
                                        onBlur={(e) => {
                                            let value = Number(e.target.value.replace(/,/g, '') || '0');
                                            value = Number(value.toFixed(0));
                                            this.onChange('m_covers', value, index)
                                        }}

                                    />
                                </div>
                            </Compared>
                        )
                    } else {
                        return (
                            <Compared data={{ index, key: 'm_covers', title, sqlName: "_5_1_4", name: record.name, type: 'number' }} >
                                <div className={`table-padding ${index == 13 || index == 16 ? 'table-color-footer' : ''} `}>
                                    {text}
                                </div>
                            </Compared>
                        )
                    }

                }
            }, {
                title: <div>Business Mix <br />业务份额</div>,
                dataIndex: 'm_business',
                key: 'm_business',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['YTD Actual - Last Year 年累计实际-去年', 'Business Mix 业务份额'];
                    return (
                        <Compared data={{ index, key: 'm_business', title, sqlName: "_5_1_4", name: record.name, type: 'percent' }} >
                            <div className={`table-padding ${index == 13 || index == 16 ? 'table-color-footer' : ''} `}>
                                {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(1) + '%'})</span> : (text * 100).toFixed(1) + '%'}
                            </div>
                        </Compared>
                    )
                }
            }, {
                title: <div>A/C <br />人均消费</div>,
                dataIndex: 'm_AC',
                key: 'm_AC',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['YTD Actual - Last Year 年累计实际-去年', 'A/C 人均消费'];
                    return (
                        <Compared data={{ index, key: 'm_AC', title, sqlName: "_5_1_4", name: record.name, type: 'number' }} >
                            <div className={`table-padding ${index == 13 || index == 16 ? 'table-color-footer' : ''} `}>
                                {numChange(text)}
                            </div>
                        </Compared>
                    )

                }
            }, {
                title: <div>REV <br />收益</div>,
                dataIndex: 'm_REV',
                key: 'm_REV',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['YTD Actual - Last Year 年累计实际-去年', 'REV 收益'];
                    if ((!noInputData.includes(index) || index == 14 || index == 15) && !print) {
                        return (
                            <Compared data={{ index, key: 'm_REV', title, sqlName: "_5_1_4", name: record.name, type: 'number' }} >
                                <div className="table-padding table-color-number">
                                    <InputNumber
                                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                        parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                        precision={0}
                                        className="table_numInput"
                                        defaultValue={text}
                                        onBlur={(e) => {
                                            let value = Number(e.target.value.replace(/,/g, '') || '0');
                                            value = Number(value.toFixed(0));
                                            this.onChange('m_REV', value, index)
                                        }}

                                    />
                                </div>
                            </Compared>
                        )
                    } else {
                        return (
                            <Compared data={{ index, key: 'm_REV', title, sqlName: "_5_1_4", name: record.name, type: 'number' }} >
                                <div className={`table-padding ${index == 13 || index == 16 ? 'table-color-footer' : ''} `}>
                                    {numChange(text)}
                                </div>
                            </Compared>
                        )
                    }

                }
            }, {
                title: <div>Revenue Mix<br /> 收入份额</div>,
                dataIndex: 'm_revenue',
                key: 'm_revenue',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['YTD Actual - Last Year 年累计实际-去年', 'Revenue Mix 收入份额'];
                    return (
                        <Compared data={{ index, key: 'm_revenue', title, sqlName: "_5_1_4", name: record.name, type: 'percent' }} >
                            <div className={`table-padding ${index == 13 || index == 16 ? 'table-color-footer' : ''} `}>
                                {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(1) + '%'})</span> : (text * 100).toFixed(1) + '%'}
                            </div>
                        </Compared>
                    )
                }
            }, {
                title: <div>Cost Amount <br /> 成本金额</div>,
                dataIndex: 'm_cost',
                key: 'm_cost',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['YTD Actual - Last Year 年累计实际-去年', 'Cost Amount 成本金额'];
                    if (!noInputData.includes(index) && !print) {
                        return (
                            <Compared data={{ index, key: 'm_cost', title, sqlName: "_5_1_4", name: record.name, type: 'number' }} >
                                <div className="table-padding table-color-number">
                                    <InputNumber
                                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                        parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                        precision={0}
                                        className="table_numInput"
                                        defaultValue={text}
                                        onBlur={(e) => {
                                            let value = Number(e.target.value.replace(/,/g, '') || '0');
                                            value = Number(value.toFixed(0));
                                            this.onChange('m_cost', value, index)
                                        }}

                                    />
                                </div>
                            </Compared>
                        )
                    } else {
                        return (
                            <Compared data={{ index, key: 'm_cost', title, sqlName: "_5_1_4", name: record.name, type: 'number' }} >
                                <div className={`table-padding ${index == 13 || index == 16 ? 'table-color-footer' : ''} `}>
                                    {numChange(text)}
                                </div>
                            </Compared>
                        )
                    }

                }
            }, {
                title: <div>Cost %  <br /> 成本百分比</div>,
                dataIndex: 'm_cost_percent',
                key: 'm_cost_percent',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['YTD Actual - Last Year 年累计实际-去年', 'Cost % 成本百分比'];
                    return (
                        <Compared data={{ index, key: 'm_cost_percent', title, sqlName: "_5_1_4", name: record.name, type: 'percent' }} >
                            <div className={`table-padding ${index == 13 || index == 16 ? 'table-color-footer' : ''} `}>
                                {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(1) + '%'})</span> : (text * 100).toFixed(1) + '%'}
                            </div>
                        </Compared>
                    )
                }
            },]
        }, {
            title: 'YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年',
            width: 1050,
            children: [{
                title: <div>Covers <br />人数</div>,
                dataIndex: 'b_covers',
                key: 'b_covers',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年', 'Covers 人数'];
                    return (
                        <Compared data={{ index, key: 'b_covers', title, sqlName: "_5_1_4", name: record.name, type: 'number' }} >
                            <div className={`table-padding ${index == 13 || index == 16 ? 'table-color-footer' : ''} `}>
                                {numChange(text)}
                            </div>
                        </Compared>
                    )

                }
            }, {
                title: <div>Business Mix <br />业务份额</div>,
                dataIndex: 'b_business',
                key: 'b_business',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年', 'Business Mix 业务份额'];
                    return (
                        <Compared data={{ index, key: 'b_business', title, sqlName: "_5_1_4", name: record.name, type: 'percent' }} >
                            <div className={`table-padding ${index == 13 || index == 16 ? 'table-color-footer' : ''} `}>
                                {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(1) + '%'})</span> : (text * 100).toFixed(1) + '%'}
                            </div>
                        </Compared>
                    )
                }
            }, {
                title: <div>A/C <br />人均消费</div>,
                dataIndex: 'b_AC',
                key: 'b_AC',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年', 'A/C 人均消费'];
                    return (
                        <Compared data={{ index, key: 'b_AC', title, sqlName: "_5_1_4", name: record.name, type: 'number' }} >
                            <div className={`table-padding ${index == 13 || index == 16 ? 'table-color-footer' : ''} `}>
                                {numChange(text)}
                            </div>
                        </Compared>
                    )

                }
            }, {
                title: <div>REV <br />收益</div>,
                dataIndex: 'b_REV',
                key: 'b_REV',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年', 'REV 收益'];
                    return (
                        <Compared data={{ index, key: 'b_REV', title, sqlName: "_5_1_4", name: record.name, type: 'number' }} >
                            <div className={`table-padding ${index == 13 || index == 16 ? 'table-color-footer' : ''} `}>
                                {numChange(text)}
                            </div>
                        </Compared>
                    )

                }
            }, {
                title: <div>Revenue Mix<br /> 收入份额</div>,
                dataIndex: 'b_revenue',
                key: 'b_revenue',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年', 'Revenue Mix 收入份额'];
                    return (
                        <Compared data={{ index, key: 'b_revenue', title, sqlName: "_5_1_4", name: record.name, type: 'percent' }} >
                            <div className={`table-padding ${index == 13 || index == 16 ? 'table-color-footer' : ''} `}>
                                {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(1) + '%'})</span> : (text * 100).toFixed(1) + '%'}
                            </div>
                        </Compared>
                    )
                }
            }, {
                title: <div>Cost Amount <br /> 成本金额</div>,
                dataIndex: 'b_cost',
                key: 'b_cost',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年', 'Cost Amount 成本金额'];
                    return (
                        <Compared data={{ index, key: 'b_cost', title, sqlName: "_5_1_4", name: record.name, type: 'number' }} >
                            <div className={`table-padding ${index == 13 || index == 16 ? 'table-color-footer' : ''} `}>
                                {numChange(text)}
                            </div>
                        </Compared>
                    )

                }
            }, {
                title: <div>Cost %  <br /> 成本百分比</div>,
                dataIndex: 'b_cost_percent',
                key: 'b_cost_percent',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年', 'Cost % 成本百分比'];
                    return (
                        <Compared data={{ index, key: 'b_cost_percent', title, sqlName: "_5_1_4", name: record.name, type: 'percent' }} >
                            <div className={`table-padding ${index == 13 || index == 16 ? 'table-color-footer' : ''} `}>
                                {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(1) + '%'})</span> : (text * 100).toFixed(1) + '%'}
                            </div>
                        </Compared>
                    )
                }
            },]
        }];

        return (
            <Spin spinning={this.state.loading}>
                <div className="table7_1_1">
                    <Row className="title" id="table5_1_4" style={{ width: this.state.print ? 3200 : 'auto' }}>
                        <Row>5.1.4 YTD - Actual Vs. Last Year 年累计 - 实际对比去年</Row>
                        <Row className="table-month">
                            <MonthPicker
                                placeholder="请选择年月"
                                monthCellContentRender={(date, local) => {
                                    return moment(date).format('M月')
                                }}
                                defaultValue={moment(this.state.date, "YYYY-MM")}
                                format="YYYY-MM"
                                onChange={(date, str) => {
                                    this.setState({
                                        date: str,
                                        data: [],
                                        loading: true
                                    });
                                    this.getDateData(str)
                                }}
                            />
                        </Row>
                        <Table
                            columns={columns}
                            dataSource={data}
                            size="middle"
                            bordered
                            id="table5_1_4"
                            pagination={false}
                            className="content"
                            style={{ width: this.state.print ? 3150 : 'auto' }}
                            scroll={this.state.print ? {} : { x: 3150 }}
                            rowKey={(record, index) => index}
                        />
                    </Row>

                    <Row className="table-footer-btn">
                        <Button
                            type="primary"
                            style={{ marginRight: 10 }}
                            onClick={() => {

                                this.setState({ print: true, loading: true }, () => {
                                    ExportExcel({
                                        id: "table5_1_4",
                                        date,
                                        name: "5.1.4 YTD - Actual Vs. Last Year 年累计 - 实际对比去年"
                                    });
                                    this.setState({ print: false, loading: false });
                                });

                            }}
                            loading={this.state.print}
                        >导出Excel</Button>
                        <Auth loading={this.state.loading} auth="edit_5_1">
                            <Button
                                type="primary"
                                style={{ marginRight: 10 }}
                                onClick={this.downloadSG}
                                loading={this.state.print}
                            >加入pdf</Button>
                            <Button
                                type="primary"
                                onClick={this.onSave}
                                loading={this.state.loadingSave}
                            >保存</Button>
                        </Auth>
                    </Row>

                    {
                        this.state.isEdit && <Prompt
                            message="5.1.4 数据还未保存,确定要离开吗?"
                        />
                    }
                </div>
            </Spin >
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/5.0/5-1/5-1-4.js